import { Button, Container, Grid, Paper, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import linkHasExpired from '../../../assets/images/link_has_expired.svg'
import { Link, withRouter } from 'react-router-dom'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import { caseIdSelector, teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector } from '../../../redux/selectors'
import defaultBackground from '../../../assets/images/default-bg.png'
import defaultLogo from '../../../assets/images/logo_benchmarc.svg'
import { getTeamBackground, getTeamBackgroundByEmail, getTeamBackgroundByEncryptedLink, getTeamLogo, getTeamLogoByEmail, getTeamLogoByEncryptedLink } from '../../../redux/actions'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	h1: {
        fontSize: '36px',
        fontWeight: '500',
        padding: '60px 0',
        lineHeight: '1.4',
        [theme.breakpoints.down('sm')]: {
			fontSize: '18px',
            padding: '20px 0',
        }
	},
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '100px',
        [theme.breakpoints.down('sm')]: {
			marginTop: '15px',
        }
    },
    paper: {
        padding: '30px 100px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
			padding: '20px 10px',
        }
    },
    buttonLogin: {
        minWidth: '300px',
        [theme.breakpoints.down('sm')]: {
			minWidth: 'auto',
        }        
    }

}))

const LinkHasExpired = ({
    intl,
    ua,
    location
}) => {

    const classes = useStyles()

    const dispatch = useDispatch()

    const backgroundLogoUrl = useSelector(teamBackgroundSelector)
    const teamLogoUrl = useSelector(teamLogoSelector)
    const teamLogoIsLoading = useSelector(teamLogoIsLoadingSelector)
    const teamBackgroundIsLoading = useSelector(teamBackgroundIsLoadingSelector)

    const caseId = useSelector(caseIdSelector)

    useEffect(
        () => {
            let params = queryString.parse(location.search)

            if (caseId) {
                dispatch(getTeamLogo())
                dispatch(getTeamBackground())
            }
            else if (params.email) {
                dispatch(getTeamLogoByEmail(params.email))
                dispatch(getTeamBackgroundByEmail(params.email))
            }
            else if (params.data) {
                dispatch(getTeamLogoByEncryptedLink(params.data))
                dispatch(getTeamBackgroundByEncryptedLink(params.data))
            }
        },
        [caseId, location]
    )

    return (
		<LoginPagesWrapper
            logoUrl={teamLogoUrl || !teamLogoIsLoading && defaultLogo}
            backgroundUrl={backgroundLogoUrl || !teamBackgroundIsLoading && defaultBackground}
			hideMenu={true}
		>
            <div className={classes.wrapper} >
                
                <Container maxWidth="lg">
                    <Grid
                        item
                        xs={12}
                    >
                        <Paper className={classes.paper} >
                        <div
                            style={{
                                height: '25vh',
                            }}
                        >
                            <img
                                src={linkHasExpired}
                                style={{
                                    margin: '0 auto 20px',
                                    display: 'block',
                                    width: 'auto',
                                    height: '100%'
                                }}
                            />
                        </div>


                        <Typography variant='h1' className={classes.h1}>
                            {intl.formatMessage({ id: 'app.expiredLink.labelText' })}
                        </Typography>

                        <Link to='/auth/login'>
                        <Button
                            className={classes.buttonLogin}
                            variant='contained'
                            color='primary'
                        >
                            { intl.formatMessage({ id: 'app.expiredLink.loginButtonText' }).toUpperCase() }
                        </Button>
                        </Link>
                        </Paper>
                    </Grid>
                </Container>

            </div>
        </LoginPagesWrapper>
    )
}

const enhance = compose(
    injectIntl,
    withRouter
)

export default enhance(LinkHasExpired)